import ReactGA from 'react-ga';

// Records NOTHING in production today: no REACT_APP_GA_CODE, and react-ga speaks Universal Analytics
// (sunset 2023-07-01). This is the single seam for a future GA4 (gtag) + consent change.
export function mkTrack(action, label, extra = {}) {
  try {
    ReactGA.event({ category: 'marketing', action, label, transport: 'beacon', ...extra });
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', action, { event_label: label, ...extra });
    }
  } catch (e) {
    /* analytics must never break a click */
  }
}
